import { Requests } from "@/services/requests";

const ENDPOINTS = {
   BASE: "rest-auth/registration"
};

const MSG = {
   CREATE_SUCCESS: "Criado com sucesso",
   ERROR_DEFAULT: "Erro ao fazer a requisição"
};
export default class Register {
   constructor(request) {
      this.request = request;
      this.moduleName = "Register";
      this.routes = {
         register: {
            simples: this.registerUser.bind(this)
         }
      };
   }
   async makeRequest({ url, method, body, headers, expectedStatus }) {
      return Requests[method]({ url, body, headers }, expectedStatus);
   }

   async registerUser(user) {
      const finalUrl = `${ENDPOINTS.BASE}/simple/`;

      return this.makeRequest({
         url: finalUrl,
         method: "POST",
         body: user,
         expectedStatus: {
            201: MSG.CREATE_SUCCESS,
            default: MSG.ERROR_DEFAULT
         }
      });
   }
}
